export const DOCS_LOAD_GENERIC_REQUEST = 'DOCS_LOAD_GENERIC_REQUEST';
export const DOCS_LOAD_GENERIC_SUCCESS = 'DOCS_LOAD_GENERIC_SUCCESS';
export const DOCS_LOAD_GENERIC_FAIL = 'DOCS_LOAD_GENERIC_FAIL';

export const DOCS_LOAD_WIRETRANSFER_REQUEST = 'DOCS_LOAD_WIRETRANSFER_REQUEST';
export const DOCS_LOAD_WIRETRANSFER_SUCCESS = 'DOCS_LOAD_WIRETRANSFER_SUCCESS';
export const DOCS_LOAD_WIRETRANSFER_FAIL = 'DOCS_LOAD_WIRETRANSFER_FAIL';

export const DOCS_FORCE_RELOAD = 'DOCS_FORCE_RELOAD';
